import * as RTK from '@reduxjs/toolkit';

export interface State {
    selectedModularPiece: number | null;
};

export const initialState: State = {
    selectedModularPiece: null,
};

export const slice = RTK.createSlice({
    name: 'modularConfigurator',
    initialState,
    reducers: {
        setSelectedModularPiece(state, action: RTK.PayloadAction<number | null>) {
            state.selectedModularPiece = action.payload;
        },
        reset() {
            return initialState;
        }
    }
});

export const { setSelectedModularPiece, reset } = slice.actions;

export const reducer = slice.reducer;